var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal"},[_c('div',{ref:"mask",staticClass:"modal-mask",class:[_vm.containerSize],on:{"click":_vm.onClickOutside}},[_c('div',{staticClass:"modal-dialog",class:`modal-dialog-${_vm.size}`},[_vm._t("body",function(){return [_vm._v(" default body ")]})],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }